import { HotWalletAdapter } from "@hot-wallet/sdk/adapter/solana";
import { Adapter } from "@solana/wallet-adapter-base";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-wallets";
import { PropsWithChildren, useMemo } from "react";

export const SolanaProvider = ({ children }: PropsWithChildren) => {
  const wallets = useMemo(() => [new PhantomWalletAdapter() as Adapter, new HotWalletAdapter() as Adapter], []);

  return (
    <ConnectionProvider endpoint={"https://mainnet.helius-rpc.com/?api-key=e5134d0c-9f20-48b6-ada5-33583b7f78fc"}>
      <WalletProvider wallets={wallets} autoConnect={true}>
        {children}
      </WalletProvider>
    </ConnectionProvider>
  );
};
